import { withChartLayout } from 'components/common';
import GenitourinaryInterventions from 'components/features/chart/system-nursing-interventions/genitourinary-interventions/GenitourinaryInterventions';

const GenitourinaryInterventionsPage = withChartLayout('Genitourinary Interventions')(GenitourinaryInterventions);
export default GenitourinaryInterventionsPage;
